import React, { useState, useEffect } from "react";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { fetchUploadHistory } from "../../api/fileService";
import { fetchAuthSession } from "aws-amplify/auth";
import { ProgressSpinner } from "primereact/progressspinner";

export default function History() {
  const [uploadHistories, setUploadHistories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHistory = async () => {
      setLoading(true);
      try {
        const session = await fetchAuthSession();
        const token = session.tokens.idToken; // Get the ID token

        if (!token) {
          throw new Error("User token is missing. Please log in.");
        }

        const history = await fetchUploadHistory(token); // Fetch upload history
        setUploadHistories(history); // Set the fetched data
      } catch (error) {
        console.error("Error fetching upload history:", error);
      } finally {
        setLoading(false); // Stop loading spinner
      }
    };

    fetchHistory();
  }, []);

  const downloadFile = (fileName) => {
    console.log(`Downloading ${fileName}`);
    // Implement the file download logic here
  };

  const renderActions = (rowData) => {
    return (
      <Button
        icon="pi pi-download"
        className="p-button-rounded p-button-text"
        onClick={() => downloadFile(rowData.fileName)}
      />
    );
  };

  const renderFileNameWithTooltip = (rowData) => {
    return (
      <div className="flex align-items-center">
        <span>{rowData.fileName}</span>
        <i
          className="pi pi-info-circle info-icon"
          style={{ marginLeft: "0.5rem", cursor: "pointer" }}
          data-pr-tooltip={`Original file name: ${rowData.originalFileName}`}
          data-pr-position="right"
        />
        <Tooltip target=".info-icon" />
      </div>
    );
  };

  const renderUploadDate = (rowData) => {
    const date = new Date(rowData.uploadDate);
    const formattedDate = `${date.getFullYear()}/${String(
      date.getMonth() + 1
    ).padStart(2, "0")}/${String(date.getDate()).padStart(
      2,
      "0"
    )} ${date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false, // Use 24-hour format
    })}`;
    return formattedDate;
  };

  const renderFileSize = (rowData) => {
    const sizeInMB = (rowData.size / (1024 * 1024)).toFixed(2); // Convert bytes to MB and round to 2 decimal places
    return `${sizeInMB} MB`;
  };

  return (
    <Card
      title="Uploaded Data"
      style={{ border: "none", boxShadow: "none", padding: "0.75rem" }}
    >
      {/* ensures the tooltip is reinitialized after the data loads */}
      {/* <Tooltip target=".pi-info-circle" key={uploadHistories.length} /> */}
      <DataTable
        value={uploadHistories}
        paginator
        rows={10}
        responsiveLayout="scroll"
        // loading={loading}
        // loadingIcon={<ProgressSpinner style={{ width: "50px", height: "50px" }} />}
        sortField="uploadDate"
        sortOrder={-1}
        emptyMessage={
          loading ? (
            <div
              className="flex align-items-center justify-content-center"
              style={{
                height: "200px", // Adjust this height as needed for the table body
                width: "100%", // Ensure it spans the full width of the table body
                display: "flex", // Flexbox for centering
                justifyContent: "center", // Center horizontally
                alignItems: "center", // Center vertically
              }}
            >
              <ProgressSpinner
                style={{
                  width: "calc(5% + 20px)", // Dynamic width
                  height: "calc(5% + 20px)", // Dynamic height
                }}
              />
            </div>
          ) : (
            <div
              className="flex align-items-center justify-content-center"
              style={{
                height: "200px", // Adjust this height as needed for the table body
                width: "100%", // Ensure it spans the full width of the table body
                display: "flex", // Flexbox for centering
                justifyContent: "center", // Center horizontally
                alignItems: "center", // Center vertically
                color: "var(--text-secondary-color)", // Use a secondary text color from the theme
              }}
            >
              No data available
            </div>
          )
        }
      >
        <Column
          field="fileName"
          body={renderFileNameWithTooltip}
          header="File Name"
          sortable
          style={{ width: "60%" }}
        />
        <Column
          field="uploadDate"
          body={renderUploadDate}
          header="Upload Date"
          sortable
          style={{ width: "20%" }}
        />
        <Column
          field="size"
          body={renderFileSize}
          header="Size (MB)"
          sortable
          style={{ width: "20%" }}
        />
        {/* <Column body={renderActions} header="Download" /> */}
      </DataTable>
    </Card>
  );
}
